import { X } from '@phosphor-icons/react';
import { cityInfoForAirport } from '../data/cityInfo';
import { airportById } from '../data/airports';
import type { Airport, GameState } from '../game/types';
import { useI18n } from '../i18n';

interface Props {
  airport: Airport;
  game: GameState;
  onClose: () => void;
  onContinue?: () => void;
}

export function CityInfoPanel({ airport, onClose, onContinue }: Props) {
  const { t } = useI18n();
  const info = cityInfoForAirport(airport);
  if (!info) return null;

  return (
    <aside className="city-info-panel" aria-label={`${info.city}${t('ui.城市信息')}`}>
      <header className="city-info-header">
        <div>
          <span className="eyebrow">{info.province}</span>
          <h2>{info.city}</h2>
          <p>{airport.nameEn} · {airport.iata}</p>
        </div>
        <button className="icon-button city-info-close" onClick={onClose} aria-label={t('ui.关闭城市信息')}><X weight="bold" size={18} /></button>
      </header>
      <section className="city-info-stats">
        <div><span>{t('ui.常住人口')}</span><strong>{info.population}</strong></div>
        <div><span>{t('ui.行政面积')}</span><strong>{info.area}</strong></div>
        <div><span>{t('ui.气候')}</span><strong>{info.climate}</strong></div>
        <div><span>{t('ui.建城年代')}</span><strong>{info.founded}</strong></div>
      </section>
      <section className="city-info-section">
        <h3>{t('ui.城市亮点')}</h3>
        <div className="city-info-highlights">
          {info.highlights.map((highlight) => (
            <span className="tag" key={highlight}>{highlight}</span>
          ))}
        </div>
      </section>
      <section className="city-info-section">
        <h3>{t('ui.历史沿革')}</h3>
        <p className="city-info-history">{info.history}</p>
      </section>
      <div className="formula-note">{t('ui.内容由 NoFlight 取自通识资料。点击右侧机场浮层继续运营。')}</div>
      {onContinue && <button type="button" className="primary-button city-info-continue" data-tutorial-city-next onClick={onContinue}>下一步</button>}
    </aside>
  );
}

export function hasCityInfo(airportId: string): boolean {
  return cityInfoForAirport(airportById(airportId)) !== undefined;
}
